const getNow = (): string => {
  return new Date().toISOString();
};

export default getNow;
